export const findFundingStage = (fundingData, requestedFundingStage) => {
    const sortedData = fundingData.sort((stageA, stageB) => stageA.threshold - stageB.threshold);
    return sortedData[requestedFundingStage - 1];
}

